"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _MeterNumberValidationHelpers = _interopRequireDefault(require("../../../../../utils/MeterNumberValidationHelpers"));
var MeterReadingGeneric = function MeterReadingGeneric(props) {
  var buildMeterAddress = function buildMeterAddress() {
    var _props$deviceData;
    var address = props.deviceData && props.deviceData.address;
    if (!address || ((_props$deviceData = props.deviceData) === null || _props$deviceData === void 0 ? void 0 : _props$deviceData.serialNumberObfuscated)) return '';
    return /*#__PURE__*/_react.default.createElement("span", {
      "data-qa": "address-data"
    }, address.street, " ", address.houseNumber, " ", address.houseNumberSupplement, /*#__PURE__*/_react.default.createElement("br", null), address.zip, " ", address.city, " ", address.positionDescription ? "(".concat(address.positionDescription, ")") : '');
  };
  var dataFromParent = props.deviceData && props.deviceData.address;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "ano-meter-reading__box--top row"
  }, /*#__PURE__*/_react.default.createElement("h1", {
    className: "text-center ano-meter-reading__headerbox__title"
  }, props.genericTitle), dataFromParent ? /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md-12 ano-meter-reading__headerbox__data-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md-6"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/_react.default.createElement("h2", {
    className: "ano-meter-reading__headerbox__subtitle "
  }, props.contractIdLabel))), /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/_react.default.createElement("h2", {
    className: "ano-meter-reading__headerbox__generic-data"
  }, _MeterNumberValidationHelpers.default.removeRedundantZeros(props.deviceData.contractAccountId))))), /*#__PURE__*/_react.default.createElement("div", {
    className: "ano-meter-reading__headerbox__divider"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md-6"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/_react.default.createElement("h2", {
    className: "ano-meter-reading__headerbox__subtitle"
  }, props.addressLabel))), /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/_react.default.createElement("h2", {
    className: "ano-meter-reading__headerbox__generic-data"
  }, buildMeterAddress()))))) : null);
};
var _default = exports.default = MeterReadingGeneric;